import { Env } from "../../utils/env.utils";
import { setupInterceptorsTo } from "./interceptors";
import axios from "axios";
const Axios = setupInterceptorsTo(axios);

Axios.defaults.baseURL = Env.getInstance().baseUrl;

export default Axios;
